<template>
    <div class="private-card">
        <div class="private-card__bg">
            <PrivateCardBg
                :lights="lights"
                @in-viewport="cardBgInViewport = $event"
            />
        </div>
        <div class="container">
            <div class="private-card__head">
                <div class="h1-h2m text-align-left-center">Космическая карта,<br>как ни крути</div>
                <a
                    class="_mt-24 _mobile-hidden button button_black button_size-sm"
                    type="button"
                    href="/upload/docs/dbo/Tarify_Private_Banking.pdf"
                    target="_blank"
                >
                    Тарифы и условия
                </a>
            </div>
        </div>
        <div class="private-card__card">
            <PrivateCardCard />
        </div>
        <UiWrapDefaultSlotItem
            ref="card-content"
            class="private-card__content"
            item-class="private-card__content-item"
            :item-style="contentPositionsVars"
            :slots="$slots.default"
            :isList="isMobile"
        />
        <div class="container _desktop-hidden ">
            <a
                class="button button_black"
                type="button"
                href="/upload/docs/dbo/Tarify_Private_Banking.pdf"
                target="_blank"
            >
                Тарифы и условия
            </a>
        </div>
    </div>
</template>
<script>
import PrivateCardBg from './PrivateCardBg.vue';
import PrivateCardCard from './PrivateCardCard.vue';
import Velocity from 'velocity-animate';
import { computed } from 'vue';
import UiWrapDefaultSlotItem from '../ui/UiWrapDefaultSlotItem.vue';
import { useStore } from '../../store';

export default {
    name: 'PrivateCard',
    components: {
        PrivateCardBg,
        UiWrapDefaultSlotItem,
        PrivateCardCard,
    },
    setup() {
        const store = useStore();

        const isMobile = computed(() => store.state.app.isMobile);

        return {
            isMobile,
        };
    },
    data() {
        return {
            /**
             * Параметры позиции кружков на орбите
             * @type {Light[]}
             * @property {number} Light.deg - отклонение в градусах против часовой стрелке, где 0 - позиция на 12 часов
             */
            lights: [
                {
                    deg: 88,
                },
                {
                    deg: 227,
                },
                {
                    deg: 282,
                },
                {
                    deg: 333,
                },
            ],
            /**
             * Параметры позиции текста
             * @type {TextPosition[]}
             * @property {number} TextPosition.top - отступ от края блока сверху
             * @property {number} TextPosition.left - отступ от края блока слева
             */
            contentPositions: [
                {
                    top: 412,
                    left: 1172,
                },
                {
                    top: 644,
                    left: 1359,
                },
                {
                    top: 938,
                    left: 1261,
                },
                {
                    top: 760,
                    left: 466,
                },
            ],
            /**
             * Состояние видимости блока во вьюпорте
             */
            cardBgInViewport: false,
        };
    },
    computed: {
        contentPositionsVars() {
            return this.contentPositions.map(({ top, left }) => ({
                '--private-card__content-item-top': top,
                '--private-card__content-item-left': left,
            }));
        },
    },
    watch: {
        cardBgInViewport: {
            immediate: true,
            handler(val) {
                const el = this.$refs['card-content']?.$el;
                if (!el || this.isMobile) return;
                if (val) {
                    Velocity(el, { opacity: 1 }, { duration: 1000, delay: 3000, mobileHA: false });
                } else {
                    el.style.opacity = 0;
                }
            }
        }
    },
    mounted() {
        const el = this.$refs['card-content']?.$el;
        if (el && !this.isMobile) el.style.opacity = 0;
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/mixins';
@import '../../assets/scss/base/functions';

.private-card {
    position: relative;
    @include not-mobile {
        @include fluid-1920('height', 1293px);
    }
    @include fluid-1920('margin-bottom', -135px, 0px);

    @include fluid('padding-top', 335px, 88px);

    &__bg {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
    }

    &__head {
        position: relative;
        @include fluid('width', 592px);
        @include mobile {
            width: 100%;
        }
    }

    &__card {
        user-select: none;
        @include mobile {
            position: relative;
            width: 100%;
            @include fluid('height', 225px);
            @include fluid('padding-left', 42px);
            @include fluid('padding-right', 42px);
        }
        @include not-mobile {
            position: absolute;
            @include fluid-1920('width', 629px);
            @include fluid-1920('height', 422px);
            @include fluid-1920('left', 672px);
            @include fluid-1920('top', 486px);
        }
    }

    &__content {
        position: static;
        @include fluid('width', 308px);
        @include mobile {
            width: 100%;
        }
        @include mobile {
            position: relative;
            @include fluid('padding-left', 0, 16px);
            @include fluid('padding-right', 0, 16px);
        }

        @at-root ul#{&} li {
            background: url('/local/templates/redesign/src/assets/img/private/card/list-disk_light.webp') no-repeat;
            @include fluid('background-size', 20px);
            @include fluid('background-position-x', 8px);
            background-position-y: 0px;
            list-style: none;
            @include fluid('padding-left', 36px);
            @include fluid('margin-bottom', 16px);
        }
    }

    &__content-item {
        width: inherit;
        @include not-mobile {
            position: absolute;
            top: calc(var(--private-card__content-item-top) / 1920 * 100vw);
            left: calc(var(--private-card__content-item-left) / 1920 * 100vw);
        }
    }

    &__item-title {
        font-weight: 500;
        @include fluid('font-size', 20px, 16px);
        @include fluid('line-height', 28px, 20px);
        @include fluid('margin-bottom', 4px);
    }

    &__item-description, &__item-description_mobile {
        @include p2;
        color: $grey-166;

        & li {
            background: url('/local/templates/redesign/src/assets/img/private/card/list-disk.webp') no-repeat;
            @include fluid('background-size', 7px);
            @include fluid('background-position-x', 0px);
            @include fluid('background-position-y', 6px);
            list-style: none;
            @include fluid('padding-left', 22px);
            @include fluid('margin-bottom', 8px);
        }
    }

    &__item-description {
        @include mobile {
            display: none;
        }
    }

    &__item-description_mobile {
        @include not-mobile {
            display: none;
        }
    }
}
</style>
